import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface Props {
  title: string;
  disabled?: boolean;
  expanded: boolean;
  children: React.JSX.Element;
  handleToggleAccordion: () => void;
  [key: string]: unknown;
}

const AccordionSection = ({
  title,
  disabled = false,
  expanded,
  children,
  handleToggleAccordion,
  ...additionalProps
}: Props) => {
  return (
    <Accordion
      expanded={expanded && !disabled}
      onChange={() => handleToggleAccordion()}
      disabled={disabled}
      sx={{ width: '100%' }}
      {...additionalProps}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ width: '100%' }}>
        <Typography>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ width: '100%' }}>{children}</AccordionDetails>
    </Accordion>
  );
};

export default AccordionSection;
